
export default function Mission() {
  return (
    <section className="py-20 bg-stone-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-heart-line text-3xl text-red-600"></i>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 font-nunito">
            Notre mission
          </h2>
          
          <p className="text-xl text-gray-600 leading-relaxed font-nunito">
            Le dépannage urgent reste un service rendu : diagnostiquer vite, proposer la solution la plus fiable, 
            compter le temps de recherche de panne et le déplacement de façon transparente.
          </p>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2 font-nunito">Diagnostic rapide</h3>
              <p className="text-gray-600 font-nunito">Identification précise du problème</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2 font-nunito">Solution fiable</h3>
              <p className="text-gray-600 font-nunito">Réparation durable et sécurisée</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2 font-nunito">Transparence</h3>
              <p className="text-gray-600 font-nunito">Tarification claire et honnête</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
